import { connect } from 'react-redux'
import Send from './Send'
import { listenForPoll } from '../../redux/actions/poll'

const mapStateToProps = ({ polls }, { params }) => ({
	poll: polls[params.pollId],
})

const mapDispatchToProps = (dispatch, { params }) => ({
	load() {
		const { pollId } = params
		dispatch(listenForPoll(pollId))
	},
})

const Container = connect(
	mapStateToProps,
	mapDispatchToProps,
)(Send)

export default Container



// WEBPACK FOOTER //
// ./src/components/send/Container.jsx